import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { NopageFoundComponent } from './nopage-found/nopage-found.component';
import { PagesModule } from './pages/pages.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AuthService } from './auth/service/auth.service';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SharedEcomerceModule } from "./pages/shared-ecomerce/shared-ecomerce.module";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServerErrorsInterceptor } from './shared/server-errors.interceptor';
import { LoaderService } from './services/api/loader.service';
import { SharedModule } from './shared/shared.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { LoginComponent } from './auth/login/login.component';
import { InicioComponent } from './pages/inicio/inicio.component';
import { ProductoComponent } from './pages/producto/producto.component';
import { PedidoComponent } from './pages/pedido/pedido.component';
import { ArticulosComponent } from './pages/articulos/articulos.component';
import { RegistroClienteComponent } from './pages/registro-cliente/registro-cliente.component';
import { CarritoComponent } from './pages/carrito/carrito.component';
import { LoginClienteComponent } from './pages/login-cliente/login-cliente.component';
import { CategoriaComponent } from './pages/categoria/categoria.component';
import { GestionPedidoDetalleComponent } from './pages/gestion-pedido-detalle/gestion-pedido-detalle.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { CambioComponent } from './pages/cambio/cambio.component';
import { PedidoClienteComponent } from './pages/pedido-cliente/pedido-cliente.component';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { NgOptimizedImage } from '@angular/common';
import { PrivacityComponent } from './pages/privacity/privacity.component';
import { CodigoDescuentoComponent } from './pages/codigo-descuento/codigo-descuento.component';
@NgModule({ declarations: [
        AppComponent,
        NopageFoundComponent,
        LoginComponent,
        InicioComponent,
        ProductoComponent,
        PedidoComponent,
        ArticulosComponent,
        RegistroClienteComponent,
        CarritoComponent,
        LoginClienteComponent,
        CategoriaComponent,
        GestionPedidoDetalleComponent,
        RedirectComponent,
        CambioComponent,
        RegistroClienteComponent,
        PedidoClienteComponent,
        PrivacityComponent,
 CodigoDescuentoComponent
    ],
    bootstrap: [AppComponent,
    ], imports: [BrowserModule,
        AppRoutingModule,
        AuthModule,
        PagesModule,
        ReactiveFormsModule,
        FormsModule,
        SharedEcomerceModule,
        BrowserAnimationsModule,
        SharedModule,
        NgxMaskDirective,
        NgxMaskPipe,
        InfiniteScrollModule,
        NgOptimizedImage
    ], providers: [
        provideNgxMask(),
        AuthService,
        LoaderService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ServerErrorsInterceptor,
            multi: true
        },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
